import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white/70 group-[.toaster]:dark:bg-white/5 group-[.toaster]:backdrop-blur-xl group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-white/40 group-[.toaster]:dark:border-white/10 group-[.toaster]:shadow-[0_8px_32px_rgba(0,0,0,0.08)] group-[.toaster]:rounded-2xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-xl",
          cancelButton:
            "group-[.toast]:bg-white/50 group-[.toast]:text-muted-foreground group-[.toast]:rounded-xl group-[.toast]:border group-[.toast]:border-white/40",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
